<template>
  <b-sidebar
    v-if="quoteDistributionItem.id"
    id="sidebar-update-quote-distribution-item"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Quote distribution') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <fieldset-component :title="$t('Quote distribution for {organization}', { organization: quoteDistributionItem.direction.code + ' - ' + $langName(quoteDistributionItem.direction.name) })">

          <validation-observer ref="quoteDistributionItemUpdate">
            <b-row>
              <b-col
                v-for="item in dcTypes"
                :key="item.id"
                md="6"
              >
                <!-- DcTypes -->
                <b-form-group
                  :label="$langName(getDcType(item.dc_type).name)"
                  label-for="dcType"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$langName(getDcType(item.dc_type).name)"
                    rules="required|integer"
                  >
                    <b-form-input
                      :id="'dcType'+item.id"
                      v-model="item.additional_confirmed_amount"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ $t('Update') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </fieldset-component>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, integer, maxValue } from '@/libs/validations/validations'
import fieldsetComponent from '@/views/components/FieldsetComponent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BRow,
    BCol,
    fieldsetComponent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      maxValue,
    }
  },
  computed: {
    quoteDistributionItem() {
      return this.$store.state[this.MODULE_NAME].quoteDistributionItem
    },
    dcTypes() {
      return JSON.parse(this.$store.state[this.MODULE_NAME].quoteDistributionItemDcTypes)
    },
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.freshData()
      hide()
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    freshData() {
      this.$refs.quoteDistributionItemUpdate.reset()
    },
    submit(hide) {
      this.$refs.quoteDistributionItemUpdate.validate().then(success => {
        if (success) {
          this.$createSwal(this, { dc_types: this.dcTypes, letter_id: this.letter.id }, `${this.MODULE_NAME}/updateAdditionalItem`, () => {
            this.$emit('refetchData')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    return {
      MODULE_NAME,
    }
  },
}
</script>
<style>
#sidebar-update-quote-distribution-item {
  width: 50rem;
}
</style>
